import React, {lazy} from "react";
import {Route, Redirect} from "react-router-dom";
import Layout from "../../_metronic/layout/Layout";
import EmailNaoVerificadoAlert from "../components/EmailNaoVerificadoAlert";

const ResumePage = lazy(() =>
    import("../pages/home/resumo/ResumePage")
);

const PerfilPage = lazy(() =>
    import("../pages/home/perfil/PerfilPage")
);

export default function UsinaPanel() {
    return (
        <Layout>
            <EmailNaoVerificadoAlert />

            <Route path="/resumo" component={ResumePage}/>
            <Route path="/perfil" component={PerfilPage}/>
        </Layout>
    );
}
